export default "/images/vendor/@coreui/icons/svg/flag/cif-it.svg?fddf04b760b1a180d8755e9fbb7c2c99";